import { render, staticRenderFns } from "./OrganismLimitDate.vue?vue&type=template&id=20bfd324&"
import script from "./OrganismLimitDate.vue?vue&type=script&lang=js&"
export * from "./OrganismLimitDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports